import React, { useState } from "react";
import searchIcon from "assets/images/fileImage/search.svg";
import "./footerSearching.scss";

const searchIconBool = true;

const FooterSearchBar2 = ({ onSearch, isHistoryOpen }) => {
  const [input, setInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) onSearch(input);
    setInput("");
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const placeholder = isMobile && isHistoryOpen
    ? "Ask Ysentinel.."
    : "Ask Ysentinel about your files..";

  return (
    <footer className="footerSearch">
      <form onSubmit={handleSubmit} className="footerSearch-pill">
        <input
          type="text"
          placeholder={placeholder}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          aria-label="Ask Ysentinel"
        />
        <button type="submit" className="searchBtn" aria-label="Search">
          {searchIconBool ? (
            <img src={searchIcon} alt="" aria-hidden={true} />
          ) : (
            "Search"
          )}
        </button>
      </form>
    </footer>
  );
};

export default FooterSearchBar2;
